import { useEffect } from 'react';
import { Hero, LearnByDoing, Opportunities } from '../components/home/HomeSections';
import { CareerPaths, JourneySteps } from '../components/home/HomePaths';

export const Home = () => {
  useEffect(() => { document.title = 'Elevate Careers | Career clarity, practical skills and real opportunities'; }, []);
  return (
    <main data-testid="home-page">
      <Hero />
      <CareerPaths />
      <JourneySteps />
      <LearnByDoing />
      <Opportunities />
    </main>
  );
};

export default Home;
